import { Environment } from '../const/Environment'
import { getEnvStore, setEnvStore } from '../store'
import { buildEnv } from '../values'

export const setEnvironment = (env: Environment): void => {
  if (!Environment[env]) {
    throw new Error(
      `Unknown env, existing: ${Object.keys(Environment).join(', ')}`,
    )
  }
  console.info('setEnvironment', env)
  setEnvStore(env)
  window.location.reload()
}

export const getEnvironment = (): Environment => {
  const localStorageEnv = getEnvStore()

  if (localStorageEnv) {
    return localStorageEnv
  }

  setEnvStore(buildEnv())

  return buildEnv()
}

export const currentEnvironmentNotBuildEnvironment = (): boolean =>
  getEnvironment() !== buildEnv()

export const isLocalhost =
  typeof window !== 'undefined'
    ? window.location.hostname === 'localhost'
    : false

export const isPrDeployment =
  typeof window !== 'undefined'
    ? window.location.hostname.startsWith('pr-') ||
      window.location.hostname.startsWith('admin-pr-')
    : false

export const isAdminPanel: boolean = (() => {
  try {
    //@ts-expect-error global defined in vite.shared.config
    return __IS_ADMIN_PANEL__
  } catch {
    return false
  }
})()
